"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOpenEvent = useOpenEvent;
var _openSubscriptionWizard = require("@ori-events/open-subscription-wizard");
var _react = require("react");
var _EWizardCustomerType = require("../types/EWizardCustomerType");
function useOpenEvent() {
  const [open, setOpen] = (0, _react.useState)(false);
  const [isFeedbackOpen, setIsFeedbackOpen] = (0, _react.useState)(false);
  const [key, setKey] = (0, _react.useState)(0);
  const [customerType, setCustomerType] = (0, _react.useState)(null);
  const [placementFromEvent, setPlacementFromEvent] = (0, _react.useState)(undefined);
  const [uriTemplateFromEvent, setUriTemplateFromEvent] = (0, _react.useState)(undefined);
  const [wizardType, setWizardType] = (0, _react.useState)(null);
  const [productCode, setProductCode] = (0, _react.useState)();
  const handleOpenEvent = (0, _react.useCallback)(({
    detail: {
      customerType: initialCustomerType = _EWizardCustomerType.EWizardCustomerType.All,
      placement,
      productCode: code,
      type: initialWizardType,
      uriTemplate
    }
  }) => {
    setCustomerType(_EWizardCustomerType.EWizardCustomerType[initialCustomerType]);
    setWizardType(initialWizardType);
    setProductCode(code);
    if (typeof placement !== 'undefined') {
      setPlacementFromEvent(placement);
    }
    if (typeof uriTemplate !== 'undefined') {
      setUriTemplateFromEvent(uriTemplate);
    }
    setOpen(true);
    setKey(current => current + 1);
  }, []);
  const handleOpenFeedback = () => {
    setIsFeedbackOpen(true);
  };
  const handleCloseFeedback = () => {
    setIsFeedbackOpen(false);
  };
  (0, _react.useEffect)(() => {
    (0, _openSubscriptionWizard.listen)(handleOpenEvent);
    return () => {
      (0, _openSubscriptionWizard.clean)(handleOpenEvent);
    };
  }, [handleOpenEvent, customerType]);
  const handleClose = (0, _react.useCallback)(() => {
    setOpen(false);
  }, []);
  return {
    customerType,
    handleClose,
    handleCloseFeedback,
    handleOpenFeedback,
    isFeedbackOpen,
    key,
    open,
    placementFromEvent,
    productCode,
    uriTemplateFromEvent,
    wizardType
  };
}
